import {createStyles, makeStyles, Theme} from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import BreadcrumbEntry from 'Shared/components/BreadcrumbEntry';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(8),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    linkText: {
      textTransform: 'capitalize',
    },
  })
);

const BreadcrumbsBar = () => {
  const classes = useStyles();
  const {breadcrumbs} = useSelector((state: ReducerState) => state.breadcrumbs);
  const hasMoreThanOneBreadcrumb = Object.keys(breadcrumbs).length > 1;

  return hasMoreThanOneBreadcrumb ? (
    <Breadcrumbs aria-label="breadcrumb" className={classes.root}>
      {Object.keys(breadcrumbs).map((key, index, crumbs) => {
        const crumb = breadcrumbs[key];
        const isLastCrumb = index === crumbs.length - 1;

        return <BreadcrumbEntry key={key} breadcrumb={crumb} isCurrent={isLastCrumb} />;
      })}
    </Breadcrumbs>
  ) : null;
};

export default BreadcrumbsBar;
